// extracted by mini-css-extract-plugin
export default {"Voxel":"Voxel_Voxel__R9tyo"};